import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=4b1f5fdf&scoped=true"
import script from "./vipList.vue?vue&type=script&lang=js"
export * from "./vipList.vue?vue&type=script&lang=js"
import style0 from "./vipList.vue?vue&type=style&index=0&id=4b1f5fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f5fdf",
  null
  
)

export default component.exports